import { AppDispatch } from '../store';
import { 
  savePlaceDraft, 
  updatePlaceDraft, 
  deletePlaceDraft, 
  clearAllPlaceDrafts, 
  setPlaceDrafts, 
  PlaceDraft 
} from '../store/slices/PlaceDraftSlice';

// Redux-based place draft utility functions
export const placeDraftUtils = {
  saveDraft: (dispatch: AppDispatch, draftData: Omit<PlaceDraft, 'id' | 'createdAt' | 'updatedAt'>) => {
    dispatch(savePlaceDraft(draftData));
  },

  updateDraft: (dispatch: AppDispatch, id: string, updatedDraft: Partial<PlaceDraft>) => {
    dispatch(updatePlaceDraft({ id, draft: updatedDraft }));
  },

  deleteDraft: (dispatch: AppDispatch, id: string) => {
    dispatch(deletePlaceDraft(id));
  },

  clearAllDrafts: (dispatch: AppDispatch) => {
    dispatch(clearAllPlaceDrafts());
  },

  setDrafts: (dispatch: AppDispatch, drafts: PlaceDraft[]) => {
    dispatch(setPlaceDrafts(drafts));
  },
};

// Re-export the PlaceDraft type for convenience
export type { PlaceDraft };
